import { styled } from '@linaria/react'
import { colors } from '../styles/colors'
import { css } from '@linaria/core'

export const DialogContainer = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  gap: 24px;
  background: ${colors.bgCard};
  width: 100%;
  max-width: 400px;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
`
export const alignLeftDialogContentCss = css`
  text-align: left;
`

export const modalDialogCss = css`
  border-radius: ${colors.radiusCardLg};
  box-shadow: ${colors.shadowLg};
`
